module.exports = __webpack_public_path__ + "static/catchingsnowflakes-323806cf0d581882b496de5dbb7a786f.jpg";